// extracted by mini-css-extract-plugin
export const podiumLeftDesktop = "statsSection-module--podium-left-desktop--1PHpm";
export const podiumRightDesktop = "statsSection-module--podium-right-desktop--1QRZk";
export const podiumLeftTablet = "statsSection-module--podium-left-tablet--1qwjT";
export const podiumRightTablet = "statsSection-module--podium-right-tablet--1xDL3";
export const podiumLeftMobile = "statsSection-module--podium-left-mobile--2IRoZ";
export const podiumRightMobile = "statsSection-module--podium-right-mobile--1rW57";